import React, { useId } from 'react'
import PropTypes from 'prop-types'

const FileCodeIcon = React.forwardRef(function FileCodeIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4453 11.168C13.9048 10.8616 14.5257 10.9858 14.832 11.4453L17.2018 15 14.832 18.5547C14.5257 19.0142 13.9048 19.1384 13.4453 18.8321 12.9858 18.5257 12.8616 17.9048 13.1679 17.4453L14.7981 15 13.1679 12.5547C12.8616 12.0952 12.9858 11.4743 13.4453 11.168ZM10.5547 11.168C11.0142 11.4743 11.1384 12.0952 10.8321 12.5547L9.20186 15 10.8321 17.4453C11.1384 17.9048 11.0142 18.5257 10.5547 18.8321 10.0952 19.1384 9.47431 19.0142 9.16796 18.5547L6.79816 15 9.16796 11.4453C9.47431 10.9858 10.0952 10.8616 10.5547 11.168Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 0H14.4142L21 6.58579V24H3V0ZM5 2V22H19V7.41421L13.5858 2H5Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 0C13.5523 0 14 0.447715 14 1V6C14 6.54772 14.4523 7 15 7H20C20.5523 7 21 7.44772 21 8C21 8.55228 20.5523 9 20 9H15C13.3477 9 12 7.65228 12 6V1C12 0.447715 12.4477 0 13 0Z"
      ></path>
    </svg>
  )
})

FileCodeIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

FileCodeIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default FileCodeIcon
